import ServiceAccount from "../Services/ServiceAccount";

function isEmail(email: string) {
	// eslint-disable-next-line
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

const service = new ServiceAccount();
let currentSearch: Promise<Response> | undefined = undefined;

export const searchEmail = (
	rule: string,
	value: string,
	callback: (message?: any) => void
) => {
	if (value && isEmail(value)) {
		currentSearch = service.fetchPage(0, 1, undefined, undefined, { filter_Username: value })
		if (currentSearch) {
			setTimeout(() => {
					currentSearch && currentSearch!
					.then(async r => {
						currentSearch = undefined;
						const res = await r.json();
						if (res.meta.total > 0) {
							callback("User Register");
						} else {
							callback();
						}
					})
					.catch(e => {
						currentSearch = undefined;
						callback();
					});
			}, 1000);
		}
	}
	callback();
	return true;
};
